export const GET_LOGOUT = 'GET_LOGOUT'
export const GET_LOGOUT_REQUEST = 'GET_LOGOUT_REQUEST'
export const GET_LOGOUT_SUCCESS = 'GET_LOGOUT_SUCCESS'
export const GET_LOGOUT_ERROR = 'GET_LOGOUT_ERROR'

export const LOGOUT_WS = 'LOGOUT_WS'
